export default [
  {
    name: 'BusinessGroups',
    path: '/business-groups',
    component: () => import('./pages/BusinessGroups'),
    meta: {
      ability: [
        {
          resource: 'business-groups',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Add BusinessGroup',
    path: '/business-groups/add',
    component: () => import('./pages/BusinessGroupDetails'),
    meta: {
      ability: [
        {
          resource: 'business-groups',
          actions: ['create'],
        },
      ],
    },
  },
  {
    name: 'Edit BusinessGroup',
    path: '/business-groups/edit/:id',
    component: () => import('./pages/BusinessGroupDetails'),
    meta: {
      ability: [
        {
          resource: 'business-groups/:id',
          actions: ['update'],
        },
      ],
    },
    props: {
      editMode: true,
    },
  },
]
